import { render } from "./StudentDiscount.vue?vue&type=template&id=6e37e804&scoped=true"
import script from "./StudentDiscount.vue?vue&type=script&lang=js"
export * from "./StudentDiscount.vue?vue&type=script&lang=js"

import "./StudentDiscount.vue?vue&type=style&index=0&id=6e37e804&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e37e804"]])

export default __exports__